import {
  SnippetElement,
  defineElement,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/common-language-modal/common-language-modal.ts
var CommonLanguageModal = class extends SnippetElement {
  onItemClick(elm) {
    var _a;
    this.inputLanguageCode.value = (_a = elm.dataset.value) != null ? _a : "";
    if (this.form) {
      this.form.submit();
    } else {
      console.log("failed to submit language form");
    }
  }
};
__decorateClass([
  query("[data-input-language-code]")
], CommonLanguageModal.prototype, "inputLanguageCode", 2);
__decorateClass([
  query("[data-button]")
], CommonLanguageModal.prototype, "buttons", 2);
__decorateClass([
  query("form")
], CommonLanguageModal.prototype, "form", 2);
__decorateClass([
  onClick("[data-button]")
], CommonLanguageModal.prototype, "onItemClick", 1);
CommonLanguageModal = __decorateClass([
  defineElement("common-language-modal")
], CommonLanguageModal);
export {
  CommonLanguageModal
};
